import React, {Component} from 'react'
import moment from 'moment'
import { displayOddsType, currencyToText, getStatus } from 'utils/converters'
import { calculateBetReturn } from 'utils/calculations'
import { connect } from 'react-redux'
import { editUserbet, deleteUserbet } from 'actions/userbets'
import MatchCell from './MatchCell'


class MybetRow extends Component {
  constructor(props) {
    super(props)
    this.changeStatus = this.changeStatus.bind(this)
    this.deleteBet = this.deleteBet.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  changeStatus(status) {
    const { dispatch } = this.props
    dispatch(editUserbet(this.props.id, {
      status: +status
    }))
  }

  onClick(e) {
    e.preventDefault()
    this.props.onClick(this.props.id)
  }

  deleteBet() {
    const { dispatch } = this.props
    dispatch(deleteUserbet(this.props.id))
  }

  render() {
    let status = getStatus[this.props.status]
    return (
      <tr className={this.props.status !== 1 ? status.className : ''} onClick={this.onClick}>
        <td className='start-cell'> {moment(this.props.match.startTime).format('MMM Do h:mm a')} </td>
        <MatchCell
          homeTeam={this.props.match.homeTeam}
          awayTeam={this.props.match.awayTeam }
          league={!!this.props.match.competition ? this.props.match.competition.name : 'No league'}
          country={this.props.match.country ? this.props.match.country : 'No country' }
          sport={ this.props.sportId }
        />
        <td>{displayOddsType(this.props.oddsType, this.props.output, this.props.oddsTypeCondition)}</td>
        <td className='bookmaker-cell'>{ this.props.bookmaker.name }</td>
        <td className='odds-cell'>
          { this.props.odds }
          { this.props.closingLine && <span className='text-muted'> / { this.props.closingLine }</span>}
        </td>
        <td>{ currencyToText(this.props.wager, this.props.currency) }</td>
        <td className='return-cell'>
          { currencyToText(calculateBetReturn(this.props.wager, this.props.odds, this.props.status), this.props.currency) }
        </td>
        <td className='status-cell'>
          { getStatus[this.props.status].text }
        </td>
      </tr>
    )
  }
}

export default connect()(MybetRow)



/** WEBPACK FOOTER **
 ** ./src/components/mybets/MybetRow.js
 **/